module.exports = {
  "fontFamily": {
    "base": {
      "value": "Montserrat",
      "type": "fontFamilies",
      "description": "Used for body copy, button, and H6"
    },
    "heading": {
      "value": "Butler",
      "type": "fontFamilies",
      "description": "All headings"
    }
  },
  "fontWeights": {
    "ultrathin": {
      "value": "100",
      "type": "fontWeights"
    },
    "thin": {
      "value": "200",
      "type": "fontWeights"
    },
    "medium": {
      "value": "500",
      "type": "fontWeights"
    },
    "light": {
      "value": "300",
      "type": "fontWeights"
    },
    "bold": {
      "value": "700",
      "type": "fontWeights"
    },
    "regular": {
      "value": "400",
      "type": "fontWeights"
    }
  },
  "fontSize": {
    "h0": {
      "value": "64px",
      "type": "fontSizes"
    },
    "h1": {
      "value": "60px",
      "type": "fontSizes"
    },
    "h2": {
      "value": "54px",
      "type": "fontSizes"
    },
    "h3": {
      "value": "48px",
      "type": "fontSizes"
    },
    "h4": {
      "value": "30px",
      "type": "fontSizes"
    },
    "h5": {
      "value": "30px",
      "type": "fontSizes"
    },
    "h6": {
      "value": "16px",
      "type": "fontSizes"
    },
    "base": {
      "value": "17px",
      "type": "fontSizes"
    },
    "button": {
      "value": "18px",
      "type": "fontSizes"
    },
    "h0-mobile": {
      "value": "54px",
      "type": "fontSizes"
    },
    "h1-mobile": {
      "value": "40px",
      "type": "fontSizes"
    },
    "h2-mobile": {
      "value": "40px",
      "type": "fontSizes"
    },
    "h3-mobile": {
      "value": "35px",
      "type": "fontSizes"
    },
    "h4-mobile": {
      "value": "20px",
      "type": "fontSizes"
    },
    "h5-mobile": {
      "value": "20px",
      "type": "fontSizes"
    },
    "h6-mobile": {
      "value": "14px",
      "type": "fontSizes"
    },
    "base-mobile": {
      "value": "16px",
      "type": "fontSizes"
    },
    "button-mobile": {
      "value": "17px",
      "type": "fontSizes"
    }
  },
  "colors": {
    "black": {
      "500": {
        "value": "#000000",
        "type": "color"
      }
    },
    "white": {
      "500": {
        "value": "#FFFFFF",
        "type": "color"
      }
    },
    "charcoal": {
      "500": {
        "value": "#636466",
        "type": "color"
      }
    },
    "ash": {
      "500": {
        "value": "#F8F8F9",
        "type": "color"
      }
    },
    "heather": {
      "500": {
        "value": "#A7A9AC",
        "type": "color"
      }
    },
    "sand": {
      "500": {
        "value": "#DCDDDE",
        "type": "color"
      }
    },
    "denim": {
      "500": {
        "value": "#00668A",
        "type": "color"
      }
    },
    "iris": {
      "500": {
        "value": "#6E4DCA",
        "type": "color"
      }
    },
    "tangerine": {
      "500": {
        "value": "#F28500",
        "type": "color"
      }
    },
    "coral": {
      "500": {
        "value": "#F26B68",
        "type": "color"
      }
    },
    "pine": {
      "500": {
        "value": "#398583",
        "type": "color"
      }
    }
  },
  "textCase": {
    "uppercase": {
      "value": "uppercase",
      "type": "textCase",
      "description": "Used for h6 and button "
    },
    "none": {
      "value": "none",
      "type": "textCase"
    }
  },
  lineHeight: {
    headings: {
      value: '1.12',
      type: 'lineHeights',
    },
    body: {
      value: '1.8',
      type: 'lineHeights',
    },
  },
};
